import { useContext, createContext } from 'react';

export enum ForcedState {
  BUTTONS_HOVER = 'BUTTONS_HOVER',
  NEXT_BUTTON_HOVER = 'NEXT_BUTTON_HOVER',
  PREVIOUS_BUTTON_HOVER = 'PREVIOUS_BUTTON_HOVER',
  SUBMIT_BUTTON_HOVER = 'SUBMIT_BUTTON_HOVER',
  INPUT_FIELDS_HOVER = 'INPUT_FIELDS_HOVER',
  INPUT_FIELDS_FOCUS = 'INPUT_FIELDS_FOCUS',
  INPUT_FIELDS_ERROR = 'INPUT_FIELDS_ERROR',
}

export const ForcedStateContext = createContext<ForcedState[]>([]);

export const useForcedState = (): ForcedState[] =>
  useContext(ForcedStateContext) || [];
